<template>
    <v-card color="lighten-3" class="primary--text pe-3">
        <v-card-text>
          <v-layout>
            <v-flex xs3 class="pt-4 pl-4">
              <v-layout align-center justify-center column>
                <v-avatar
                  color="grey"
                  size="60">
                    <img v-if="frentista.pessoa && frentista.pessoa.url_imagem_perfil" :src="frentista.pessoa.url_imagem_perfil" alt="trevor">
                    <v-icon dark v-else>face</v-icon>
                </v-avatar>
              </v-layout>
            </v-flex>
            <v-flex xs9>
              <v-card-title class="text-xs-left">
                <v-layout column justify-start>
                  <div class="headline">{{ frentista.pessoa ? frentista.pessoa.nome_completo : `${frentista.nome} ${frentista.sobrenome}` }}</div>
                  <div>CPF: {{ frentista.pessoa ? frentista.pessoa.cpf : frentista.cpf }}</div>
                  <div>Mat.: {{ frentista.matricula }}</div>
                  <div>ID.: {{ frentista.pessoa ? frentista.pessoa.id_pessoa : 'Não possui' }}</div>
                </v-layout>
              </v-card-title>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-list two-line v-if="frentista.pessoa">
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="success">phone</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ frentista.pessoa.telefone }}</v-list-tile-title>
              <v-list-tile-sub-title>Telefone principal</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon color="info">chat</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider inset></v-divider>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="error">mail</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ frentista.pessoa.email }}</v-list-tile-title>
              <v-list-tile-sub-title>Email pessoal</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset></v-divider>
        </v-list>
        <v-card-actions>
          <v-btn block flat @click="$emit('fechar')">Fechar</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: ['frentista'],
    data: () => ({})
}
</script>
